import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AppRole } from 'api/types/user';
import avatarPlaceholder from 'assets/images/placeholders/ProfilePicEmpty.webp';
import * as SC from './styles';

export interface User {
  id: string;
  profilePhoto: string;
  firstName: string;
  lastName: string;
  role: string;
  slug?: string;
}

interface Props {
  user: User;
  onAccountFilterResultClick: (id: string, role: string, slug?: string) => void;
}

export default function AccountFilterResult({ user, onAccountFilterResultClick }: Props) {
  const { t } = useTranslation();

  const displayUserRole = (role: string): string => {
    if (role === AppRole.ContentCreator) {
      return t(`general.exminder`);
    }
    if (role === AppRole.Consumer) {
      return t(`general.explorer`);
    }
    return t(`general.popularPerson`);
  };

  const handleResultClick = () => {
    onAccountFilterResultClick(user.id, user.role, user.slug);
  };

  return (
    <SC.Container onClick={handleResultClick}>
      <SC.AvatarContainer
        src={user.profilePhoto}
        onError={(e: SyntheticEvent<HTMLImageElement>) => {
          e.currentTarget.src = avatarPlaceholder;
        }}
      />
      <SC.UserDetails>
        <SC.BoldText>{`${user.firstName} ${user.lastName}`}</SC.BoldText>
        <SC.RegularText>{displayUserRole(user.role)}</SC.RegularText>
      </SC.UserDetails>
    </SC.Container>
  );
}
